import { SampleBoardStatus } from "@app/strain/sample-boards/models/sample-board-status.enum";
import { SampleBoardMaterialRequest } from "@app/strain/sample-boards/models/material-requests/sample-board-material-request.model";
import { SampleBoardDocumentation } from "@app/strain/sample-boards/models/documentation/sample-board-documentation.model";
import { SampleBoardBuildRequest } from "@app/strain/sample-boards/models/build/sample-board-build-request.model";
import { SampleBoardValidateRequest } from "@app/strain/sample-boards/models/validate/sample-board-validate-request.model";
import { SampleBoardItem } from "@app/strain/sample-boards/models/sample-board-item.model";
import { SampleBoardType } from "@app/strain/sample-boards/models/sample-board-type.enum";

export class SampleBoard {
    id: number;
    name: string;
    quantityAvailable: number;
    quantityReady?: number;
    location?: string;
    isPartOfDestructiveProcess?: boolean;
    type?: SampleBoardType;
    status?: SampleBoardStatus;

    // Documentation Tab
    documentation?: SampleBoardDocumentation;

    // Material Requests Tab
    materialRequests?: SampleBoardMaterialRequest[];

    // Sample Build Requests Tab
    buildRequests?: SampleBoardBuildRequest[];

    // Validate Requests Tab
    validateRequests?: SampleBoardValidateRequest[]

    // Stock Tab
    items?: SampleBoardItem[];

    constructor(entry: any = {}) {
        this.id = entry?.id ?? 0;
        this.name = entry?.name ?? '';
        this.quantityAvailable = entry?.quantityAvailable ?? 0;
        this.quantityReady = entry?.quantityReady ?? 0
        this.type = entry?.type as SampleBoardType;
        this.isPartOfDestructiveProcess = entry?.isPartOfDestructiveProcess
            ?? (this.type ? this.type === SampleBoardType.Destructive : false);
        this.status = entry?.status as SampleBoardStatus;
        this.location = entry?.location ?? '';

        this.documentation = entry?.documentation ? new SampleBoardDocumentation(entry.documentation) : null;
        this.materialRequests = entry?.materialRequests
            ? entry.materialRequests.map(req => new SampleBoardMaterialRequest(req))
            : [];
        this.buildRequests = entry?.buildRequests
            ? entry.buildRequests.map(req => new SampleBoardBuildRequest(req))
            : [];
        this.validateRequests = entry?.validateRequests
            ? entry.validateRequests.map(req => new SampleBoardValidateRequest(req))
            : [];
        this.items = entry?.items
            ? entry.items.map(item => new SampleBoardItem(item))
            : [];
    }
}
